import React, { useState, useRef } from 'react'
import PageLayout from '@layouts/PageLayout'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import {
  Button,
  Input,
  Table,
  Dropdown,
  Space,
  Popconfirm,
  message,
} from 'antd'
import Fetch from '@components/CRUD/Fetch'
import { EllipsisOutlined } from '@ant-design/icons'
import Create from './Create'
import { client } from '@utils/client'
import Edit from './Edit'
import moment from 'moment'

const List = () => {
  const { t } = useLocalization()
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const [modalCreateOpen, setmodalCreateOpen] = useState(false)
  const [keyword, setKeyword] = useState()
  const [modalEditOpen, setModalEditOpen] = useState(false)
  const [defaultValues, setDefaultValues] = useState({})

  const fetch = async ({ page, pageSize, keyword }) => {
    const result = await client
      .get('/campaign', {
        params: {
          page: page,
          limit: pageSize,
          keyword: keyword,
        },
      })
      .then((res) => res.data)

    return result
  }

  const columns = [
    {
      title: t('campaign.list.campaignId'),
      dataIndex: 'campaignId',
      key: 'campaignId',
      width: 75,
    },
    {
      title: t('campaign.list.shopName'),
      dataIndex: 'title',
      key: 'title',
      width: 50,
    },
    {
      title: t('campaign.list.description'),
      dataIndex: 'description',
      key: 'description',
      width: 100,
    },
    {
      title: t('campaign.list.discount'),
      dataIndex: 'discount',
      key: 'discount',
      width: 50,
    },
    {
      title: t('campaign.list.net'),
      dataIndex: 'net',
      key: 'net',
      width: 50,
    },
    {
      title: t('campaign.list.period'),
      width: 100,
      render: function status(dataRow) {
        return (
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            <li>
              {t('campaign.list.startDate')} : {dataRow.startDate}
            </li>
            <li>
              {t('campaign.list.endDate')} : {dataRow.endDate}
            </li>
          </ul>
        )
      },
    },

    {
      title: t('campaign.list.status'),
      width: 100,
      render: function status(dataRow) {
        if (
          moment().isBetween(
            moment(dataRow.startDate),
            moment(dataRow.endDate),
            'date',
            []
          )
        ) {
          return (
            <span style={{ color: 'green' }}>
              {t('campaign.list.statusActive')}
            </span>
          )
        }
        if (moment().isBefore(moment(dataRow.startDate))) {
          return (
            <span style={{ color: 'yellow' }}>
              {t('campaign.list.statusPending')}
            </span>
          )
        }
        return (
          <span style={{ color: 'red' }}>
            {t('campaign.list.statusExpired')}
          </span>
        )
      },
    },
    {
      title: '',
      key: 'edit',
      width: 61,
      render: function shopEvent(record) {
        const items = [
          {
            key: '1',
            label: (
              <a
                onClick={() => {
                  setModalEditOpen(true)
                  setDefaultValues(record)
                }}
              >
                <Space>{t('campaign.list.edit')}</Space>
              </a>
            ),
          },
          {
            type: 'divider',
          },
          {
            key: '2',
            label: (
              <div>
                <Popconfirm
                  placement="left"
                  title={t('campaign.list.deleteConfirmQuestion')}
                  okText={t('campaign.list.okText')}
                  cancelText={t('campaign.list.cancelText')}
                  onConfirm={() => onDelete(record.id)}
                >
                  <a href="#">
                    <Space
                      style={{
                        width: '100%',
                        color: '#56B9C3',
                        justifyContent: 'center',
                      }}
                    >
                      {t('campaign.list.delete')}
                    </Space>
                  </a>
                </Popconfirm>
              </div>
            ),
          },
        ]
        return (
          <>
            <div>
              <Dropdown
                menu={{
                  items,
                }}
                trigger="click"
              >
                <EllipsisOutlined
                  style={{ fontSize: '32px', color: '#005596' }}
                />
              </Dropdown>
            </div>
          </>
        )
      },
    },
  ]
  const handleReload = () => {
    fetchRef.current.reload()
  }
  const onDelete = async (id) => {
    try {
      await client.delete(`/campaign/${id}`)
      message.success(t('campaign.list.deleteSuccess'))
      handleReload()
    } catch (e) {
      message.error(t('campaign.list.deleteeFailed'))
    }
  }
  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const style = {
    btnAddData: { borderRadius: '5px', width: '165px', height: '40px' },
    divSearch: {
      width: '100%',
      display: 'flex',
      gap: '20px',
      marginBottom: '20px',
    },
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Fetch fetch={fetch} params={{ page, pageSize, keyword }} ref={fetchRef}>
        {({ data, total }) => (
          <>
            <PageLayout
              title={t('campaign.list.title')}
              shownBack={false}
              extra={[
                <Button
                  type="primary"
                  key="modalCreate"
                  icon=""
                  onClick={() => setmodalCreateOpen(true)}
                  style={style.btnAddData}
                >
                  {t('campaign.list.addData')}
                </Button>,
              ]}
            >
              <div style={style.divSearch}>
                <SearchInput fetchData={(keyword) => setKeyword(keyword)} />
              </div>

              <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                onChange={handleChange}
                pagination={{
                  defaultCurrent: defaultPageSize,
                  defaultPageSize: defaultPageSize,
                  current: page,
                  pageSize,
                  total,
                }}
              ></Table>
            </PageLayout>
          </>
        )}
      </Fetch>

      <Create
        modalCreateOpen={modalCreateOpen}
        setmodalCreateOpen={setmodalCreateOpen}
      />
      <Edit
        modalEditOpen={modalEditOpen}
        setModalEditOpen={setModalEditOpen}
        defaultValues={{
          ...defaultValues,
          posterImages: defaultValues.posterImages || [],
        }}
      />
    </>
  )
}
const SearchInput = ({ fetchData }) => {
  const { t } = useLocalization()
  const [keyword, setKeyword] = useState()
  const style = {
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Input
        defaultValue={keyword}
        placeholder=""
        style={style.inputSearch}
        onChange={(e) => setKeyword(e.target.value)}
      />

      <Button
        style={style.btnSearch}
        type="primary"
        key="reload"
        onClick={() => fetchData(keyword)}
      >
        {t('campaign.list.search')}
      </Button>
    </>
  )
}

SearchInput.propTypes = {
  fetchData: PropTypes.func,
}
export default List
